import { asJSONSafe } from "../functions";

const cachePrefix = "cache__";

export function CacheService() {
  return {
    cache: {},
    getOrCreate: async function (key, request, getFunc, expirationMinutes) {
        try {
            let result = await this.get(key, request);

            if (result == null) {
                result = await getFunc();
                if (result == null)
                    return result;
                try {
                    await this.set(key, request, result, expirationMinutes);
                } catch (e) {
                    console.error(e);
                    return result;
                }
            }

            return result;
        } catch (e) {
            console.error(e);
        }

        return null;
    },
    get: async function (key, request) {
        const requestKey = request ? JSON.stringify(request) : '';

        const cacheKey = `${cachePrefix}${key}${requestKey}`;

        let result = this.cache[cacheKey];

        if (result == null) {
            result = localStorage.getItem(cacheKey);
            
            if (result != null) {
                result = asJSONSafe(result);
                this.cache[cacheKey] = result;
            }
        }

        if (result == null)
            return result;

        const expiration = result.expiration;

        const date = new Date();

        if (date > expiration)
            return null;

        return result.value;
    },
    set: async function (key, request, value, expirationMinutes) {
        const expiration = new Date();
        expiration.setMinutes(expiration.getMinutes() + expirationMinutes);

        const cacheItem = {
            expiration,
            value
        }

        const requestKey = request ? JSON.stringify(request) : '';
        const cacheKey = `${cachePrefix}${key}${requestKey}`;
        this.cache[cacheKey] = cacheItem;

        try {
            const s = JSON.stringify(cacheItem);
            localStorage.setItem(cacheKey, s);
        } catch (e) {
            console.error(e);
        }
    },
  }
}
